import { Snackbar, Alert, Slide, Box, Typography } from "@mui/material";
import { CheckCircle, ErrorOutline, WarningAmber, Info } from "@mui/icons-material";
import React from "react";

type Props = {
  open: boolean;
  message: string;
  severity?: "success" | "error" | "warning" | "info";
  onClose: () => void;
  duration?: number;
};

function SlideUpTransition(props: any) {
  return <Slide {...props} direction="up" />;
}

// 고급스러운 색/아이콘 매핑
const toastStyles = {
  success: {
    icon: <CheckCircle sx={{ color: "#299f6b", fontSize: 32, mr: 1 }} />,
    bg: "rgba(230,247,236,0.97)",
    border: "2px solid #299f6b",
    color: "#17694c",
    shadow: "0 6px 24px #299f6b22"
  },
  error: {
    icon: <ErrorOutline sx={{ color: "#d32f2f", fontSize: 32, mr: 1 }} />,
    bg: "rgba(255,236,238,0.97)",
    border: "2px solid #d32f2f",
    color: "#a5181e",
    shadow: "0 6px 24px #d32f2f22"
  },
  warning: {
    icon: <WarningAmber sx={{ color: "#ffb300", fontSize: 32, mr: 1 }} />,
    bg: "rgba(255,248,225,0.96)",
    border: "2px solid #ffb300",
    color: "#946a00",
    shadow: "0 6px 24px #ffb30022"
  },
  info: {
    icon: <Info sx={{ color: "#1976d2", fontSize: 32, mr: 1 }} />,
    bg: "rgba(232,244,253,0.97)",
    border: "2px solid #1976d2",
    color: "#164879",
    shadow: "0 6px 24px #1976d222"
  },
};

const AdminToast = ({
  open,
  message,
  severity = "success",
  onClose,
  duration = 3000,
}: Props) => {
  const style = toastStyles[severity];

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={onClose}
      TransitionComponent={SlideUpTransition}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      sx={{
        zIndex: 15000,
        mb: 3, // 하단 여백 추가
        "& .MuiSnackbarContent-root": {
          p: 0,
          bgcolor: "transparent",
          boxShadow: "none",
        },
      }}
    >
      <Box
        sx={{
          minWidth: { xs: "82vw", sm: 350 },
          maxWidth: 420,
          mx: "auto",
          borderRadius: 3,
          boxShadow: style.shadow,
          border: style.border,
          background: style.bg,
          display: "flex",
          alignItems: "center",
          px: 2.8,
          py: 1.8,
          gap: 1.6,
        }}
      >
        {style.icon}
        <Typography
          variant="subtitle1"
          fontWeight={800}
          sx={{
            color: style.color,
            fontSize: 17,
            letterSpacing: "-0.5px",
            flex: 1,
            lineHeight: 1.45,
            textAlign: "center",
            wordBreak: "keep-all",
            pr: 0.5,
          }}
        >
          {message}
        </Typography>
      </Box>
    </Snackbar>
  );
};

export default AdminToast;
